const config = {
  apiGateway: {
    REGION: 'us-west-2',
    INTERNAL_API_URL: 'https://as4hy8e4ff.execute-api.us-west-2.amazonaws.com/prod',
    COMPANY_API_URL: 'https://szy3b58fdk.execute-api.us-west-2.amazonaws.com/prod'
  },
  reactApp: {
    VERSION: 'taxonomy-company-1.13.4',
    HOSTNAME: 'https://company.us.forwood.one'
  },
  configurationService: {
    URL: 'https://config.us.forwood.one',
    WEBSOCKET: 'wss://worao5bibi.execute-api.us-west-2.amazonaws.com/prod'
  },
};

export default config;